import type { RunReport } from "../types";

/** The names and NPI a run was captured with. */
export function getReportIdentity({
  providerName,
  identity,
}: {
  providerName?: string;
  identity?: RunReport["identity"];
}) {
  const cleanName = (name: string) => name.trim().replace(/\s+/g, " ");
  const names = (identity?.names ?? []).map(cleanName).filter(Boolean);
  const primaryName = cleanName(providerName ?? "") || names[0];
  const seenNames = new Set([primaryName?.toLowerCase()]);
  const additionalNames = names.filter((name) => {
    const normalized = name.toLowerCase();
    if (seenNames.has(normalized)) {
      return false;
    }
    seenNames.add(normalized);
    return true;
  });
  return { primaryName, additionalNames, npi: identity?.npi };
}
